module.exports = __webpack_public_path__ + "static/media/mongo-icon.df1d2359.png";